import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import RowPagination from "components/General/RowPagination";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import MessageRow from "components/MessageCenter/MessageRow";
import { useRowPagination } from "hooks/useRowPagination";
import getCompanyWideAlerts from "service/CSRAdminAlerts/GetAlerts";
import moment from "moment/moment";
import { AgentData } from "context/Agent/DataProvider";
import { useContext } from "react";

export default function CompanyAlertsTab() {
  const [isLoading, setIsLoading] = useState(true);
  const [companyAlerts, setCompanyAlerts] = useState([]);
  const { t } = useTranslation();
  const { agentPolicies } = useContext(AgentData);
  const { rowsForDisplay: current, rowPaginationProps: paginationProps } =
    useRowPagination(companyAlerts, [3, 10, 25, "all"]);

  useEffect(() => {
    getCompanyWideAlerts()
      .then((response) => {
        setIsLoading(false);
        if (response && response?.activeAlerts?.length > 0) {
          setCompanyAlerts(
            response?.activeAlerts
              .filter(
                (a) =>
                  moment(a.startDate) <= moment() &&
                  a.group?.toLowerCase() === "companywide"
              )
              .map((alert) => {
                return {
                  ...alert,
                  type: "Company Alert",
                  document: {
                    typeOfDocument: "COMPANY ALERTS",
                    description: alert?.message,
                  },
                };
              })
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <EverlakeLoadingOverlay
      isLoading={isLoading}
      loadingText={t("AlertsCorrespondence-alertsTab-loading-text")}
    >
      {current?.length > 0 ? (
        <>
          {current.map((message) => (
            <div className="my-2" key={message.id}>
              <MessageRow
                key={message.id}
                message={message}
                policy={agentPolicies.find(
                  (policy) => policy.oldPolicy === message.oldPolicy
                )}
              />
            </div>
          ))}
          <RowPagination {...paginationProps} />
        </>
      ) : (
        <div className="border border-dashed border-ui-gray p-6 my-6">
          <div className="text-center">
            <div className="text-xl font-bold">
              {t("AlertsCorrespondence-alertsTab-text-1")}
            </div>
          </div>
        </div>
      )}
    </EverlakeLoadingOverlay>
  );
}
